import * as types from '../constants'
import { Record, Map } from 'immutable'

const listingsRecord = Record({
  data: Map(),
  count: 1,
  isLoading: false,
  error: null,
})

const initialState = new listingsRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LISTINGS_SUCCESS: {
      const newState = state.merge({
        data: Map(action.data),
        count: action.count,
        isLoading: false,
        error: null,
      })
      return newState
    }
    case types.FETCH_LISTINGS_LOADING: {
      return state.set('isLoading', true)
    }
    case types.FETCH_LISTINGS_ERROR: {
      return state.merge({ isLoading: false, error: action.error })
    }
    case types.FLAG_PROPERTY_LISTING: {
      return state.merge({
        data: state.get('data').delete(action.id),
        count: state.get('count') - 1,
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/listings.js